import React from 'react'
import { Redirect } from 'react-router-dom'
import { t } from 'i18next'
import Navigation from 'Components/Navigation'
import useValidatePermission from 'Hooks/useValidatePermission'
import { VAPermissions, ROUTES } from 'Utils/constants'
import './pickingFlow.css'
import PickingFlowManager from './PickingFlowManager'

export default function PickingFlow() {
  const hasPickingFlowPermission = useValidatePermission(
    VAPermissions.settingsPickingFlow
  )

  if (!hasPickingFlowPermission) {
    return <Redirect to={ROUTES.home} />
  }

  return (
    <>
      <Navigation />
      <div
        className="picking-flow-container"
        data-testid="container-picking-flow">
        <div className="picking-flow-header">
          <h1 className="picking-flow-title">
            {t('PICKING_FLOW_SETTINGS.TITLE')}
          </h1>
        </div>
        <PickingFlowManager />
      </div>
    </>
  )
}
